import {Locales} from '@netx/core-next/locales/utils/Locales';
import {CategoryType} from './constants';

export const CategoryIdRuleLabel = Locales((i18n) => ({
	TYPE: i18n('i18n.category'),
}));

export const CategoryIdTypeLabel: Record<CategoryType, string> = Locales(
	(i18n) => ({
		[CategoryType.EXCLUDE]: i18n('i18n.exclude'),
		[CategoryType.EXCLUDE_RECURSIVE]: i18n('i18n.excludeRecursive'),
		[CategoryType.ONLY]: i18n('i18n.only'),
		[CategoryType.ONLY_RECURSIVE]: i18n('i18n.onlyRecursive'),
	}),
);
